import { createAuthApi } from '@modeling/account';
import { resolvePydcApiBaseUrl } from './env';

export const pydcApi = createAuthApi(resolvePydcApiBaseUrl());
